<template>
  <div id="app">
    <div class="container" v-if="currentStep === 'ageCheck'">
      <div class="content">
        <AgeCheck @ageValidated="handleAgeValidated" />
      </div>
    </div>

    <Wrapper v-show="currentStep != 'ageCheck'">
      <Prologue v-show="currentStep === 'prologue'" />
      <ChooseName v-show="currentStep === 'chooseName'" />
      <Fight v-if="currentStep === 'fight'" />
      <Exit v-if="currentStep === 'exit'" />
    </Wrapper>
  </div>
</template>

<script>
import Wrapper from "@/components/Wrapper";
import AgeCheck from "@/components/AgeCheck";
import Prologue from "@/components/Prologue";
import ChooseName from "@/components/ChooseName";
import Fight from "@/components/Fight";
import Exit from "@/components/Exit";
import i18n from "@/plugins/i18n";
import { useGameTracking } from "@/composables/useGameTracking";

export default {
  components: { Wrapper, AgeCheck, Prologue, ChooseName, Fight, Exit },
  created() {
    this.$store.dispatch("disableScroll");
  },
  beforeDestroy() {
    // Remove beforeunload listener
    if (this.handleBeforeUnload) {
      window.removeEventListener("beforeunload", this.handleBeforeUnload);
    }
    this.$store.dispatch("enableScroll");
  },
  mounted() {
    this.$store.dispatch("disableScroll");
    // does this prevent double click default on ios Safari?
    document.addEventListener("dblclick", function (e) {
      e.preventDefault();
    });

    // check for language query
    let lang = new URL(location.href).searchParams.get("lang");
    let country = new URL(location.href).searchParams.get("country");
    let campaignId = new URL(location.href).searchParams.get("campaignId");

    if (lang) {
      i18n.locale = lang;
      this.$store.commit("setLanguage", lang);
    }

    if (country) {
      this.$store.commit("setCountry", country);
    } else {
      this.$store.commit("setCountry", "intl");
    }

    // set white glass color if in DACH region (language German)
    if (lang === "de") {
      this.$store.commit("setGlassColor", "white");
    }

    // Initialize KPI Tracker session
    const { kpiTracker, session } = useGameTracking();
    this.kpiTracker = kpiTracker;
    this.session = session;

    // Handle page unload - update session before user leaves
    this.handleBeforeUnload = () => {
      session.updateSessionProgressOnUnload(kpiTracker.getKpiData());
    };

    // Initialize session when coming to the page
    // IMPORTANT: Don't reset progress to 0 - it will be loaded from existing session if available
    session.getFingerprintAndInitializeSession(campaignId)
      .then(() => {
        const currentProgress = kpiTracker.progress?.value ?? 0;
        console.log("[App] Session initialized, current progress:", currentProgress);
      })
      .catch((error) => {
        console.error("[App] Error initializing session on page load:", error);
      });

    // Add beforeunload listener
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    enableScroll() {
      this.$store.dispatch("enableScroll");
    },
    async handleAgeValidated() {
      // Track step change to prologue
      const { kpiTracker, session } = useGameTracking();
      try {
        await session.updateSessionProgress(kpiTracker.getKpiData(), {
          step: "prologue",
        });
      } catch (error) {
        console.error("Error updating session for prologue step:", error);
      }
      this.currentStep = "prologue";
    },
  },
};
</script>

<style scoped>
.container {
  height: 100dvh;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
